"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var play_api_1 = require("@l2p/play-api");
var prepareRewards = function (_a) {
    var rewards = _a.rewards, currency = _a.currency;
    if (rewards) {
        return rewards.map(function (item, idx) {
            var _a, _b, _c, _d;
            return {
                amount: (item === null || item === void 0 ? void 0 : item.type) === play_api_1.LotteryRewardType.Cash
                    ? ((_b = (_a = item === null || item === void 0 ? void 0 : item.cashAmount) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.currency === currency; })) === null || _b === void 0 ? void 0 : _b.amount) || 0
                    : 0,
                freeSpins: (item === null || item === void 0 ? void 0 : item.type) === play_api_1.LotteryRewardType.FreeRounds ? (_c = item === null || item === void 0 ? void 0 : item.bonus) === null || _c === void 0 ? void 0 : _c.title : '',
                stuffReward: (item === null || item === void 0 ? void 0 : item.type) === play_api_1.LotteryRewardType.Stuff ? "".concat(item.stuffReward) : '',
                bonus: (item === null || item === void 0 ? void 0 : item.type) === play_api_1.LotteryRewardType.Bonus ? (_d = item === null || item === void 0 ? void 0 : item.bonus) === null || _d === void 0 ? void 0 : _d.title : null,
                place: idx + 1,
            };
        });
    }
    return [];
};
exports.default = prepareRewards;
